module.exports = __webpack_public_path__ + "img/cloud-storage.8a5055fe.svg";